exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".purchase-steps .step0:after{content:\"Price\"}.purchase-steps .step1:after{content:\"Mortgage\"}.purchase-steps .step2:after{content:\"About you\"}.purchase-steps .step3:after{content:\"Property\"}.purchase-steps .step4:after{content:\"Email\"}.purchase-steps .step5:after{content:\"Closing Cost\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/purchase/purchase.scss
// module id = 480
// module chunks = 0